import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * ThemeActions Component
 *
 * Displays the header with title, description, and action buttons
 * (Back, Refresh, Save) for the theme customizer.
 *
 * @param {Object} props
 * @param {Object} props.theme - Current theme object (optional)
 * @param {Function} props.onBack - Callback for back button
 * @param {Function} props.onRefresh - Callback for refresh button
 * @param {Function} props.onSave - Callback for save button
 * @param {boolean} props.saving - Whether save is in progress
 */
function ThemeActions({ theme, onBack, onRefresh, onSave, saving }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box>
        <Typography variant="h4" gutterBottom>
          Theme Customizer
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          {theme
            ? `Editing: ${theme.theme_name || 'Theme'}`
            : 'Advanced theme customization with live preview'}
        </Typography>
      </Box>
      <Box>
        {onBack && (
          <Button
            variant="outlined"
            onClick={onBack}
            sx={{ mr: 1 }}
            disabled={saving}
          >
            Back to Themes
          </Button>
        )}
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
          sx={{ mr: 1 }}
          disabled={saving}
        >
          Refresh
        </Button>
        <Button
          variant="contained"
          startIcon={saving ? <CircularProgress size={24} /> : <SaveIcon />}
          onClick={onSave}
          disabled={saving}
          color="primary"
        >
          {saving ? 'Saving...' : 'Save Theme'}
        </Button>
      </Box>
    </Box>
  );
}

export default ThemeActions;
